import { SaveButton } from "components/Buttons"
import React, { useState } from "react"
import { connect } from "react-redux"
import Select from "react-select"
import { Col, Row } from "reactstrap"
import { addTags, hideAddTagModal } from "store/actions"

const AddTagsForm = ({
  metaTags,
  selectedUsers,
  hideAddTagModal,
  vendorId,
  addTags,
  callbackParams,
  loading,
  resetSelectedUsers,
}) => {
  const [selectedTags, setSelectedTags] = useState([])
  const [showErrorMessage, setShowErrorMessage] = useState(false)

  const addTagHandler = () => {
    if (!selectedTags || selectedTags?.length === 0) {
      setShowErrorMessage(true)
    } else {
      addTags({
        values: {
          tags: selectedTags?.map(tag => tag?.value),
          users: selectedUsers,
          vendor_id: vendorId,
        },
        callbackParams,
      })
      resetSelectedUsers()
    }
  }

  return (
    <React.Fragment>
      {showErrorMessage && (
        <Row>
          <Col>
            <p style={{ color: "red" }}>You have to select at least one tag!</p>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <p>Add tags to {selectedUsers?.length} selected users</p>
        </Col>
      </Row>
      <Row>
        <Select
          value={selectedTags}
          isMulti={true}
          options={metaTags.map(tag => ({
            label: tag.tag,
            value: tag.id,
          }))}
          classNamePrefix="select2-selection"
          onChange={value => {
            setSelectedTags(value)
            if (showErrorMessage) setShowErrorMessage(false)
          }}
        />
      </Row>
      <Row className="justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={hideAddTagModal}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Add tags"
            onClick={addTagHandler}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  metaTags: state.Tags.metaTags,
  vendorId: state.Login.vendorId,
  loading: state.people.loading,
})

const mapDispatchToProps = dispatch => ({
  hideAddTagModal: () => dispatch(hideAddTagModal()),
  addTags: values => dispatch(addTags(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddTagsForm)
